'use es6';

import http from 'hub-http/clients/apiClient';
const BASE_URL = 'cms-assets-file-copy/api/v1';
/**
 * GET cms-assets-file-copy/api/v1/copy/access
 */

export function getAccessPortals() {
  return http.get(`${BASE_URL}/copy/access`);
}
/**
 * POST cms-assets-file-copy/api/v1/copy/bulk
 */

export function bulkCopyToPortal(requestedAssets, dependentAssets) {
  return http.post(`${BASE_URL}/copy/bulk`, {
    data: {
      requestedAssets,
      dependentAssets
    }
  });
}
/**
 * GET cms-assets-file-copy/api/v1/copy/status/bulk
 */

export function getBulkCopyStatus(copyIds) {
  return http.get(`${BASE_URL}/copy/status/bulk`, {
    query: {
      ids: copyIds
    },
    timeout: 35000,
    withXhr: xhr => {
      // In this instance, we don't want to retry on 500's.
      // See https://git.hubteam.com/HubSpot/DesignManagerUI/issues/6172
      xhr.onreadystatechange = () => xhr.status === 500 && xhr.abort();
    }
  });
}
/**
 * GET cms-assets-file-copy/api/v1/copy/{id}
 */

export function getCopyStatus(id) {
  return http.get(`${BASE_URL}/copy/${id}`, {
    query: {
      muteError: true
    },
    withXhr: xhr => {
      // In this instance, we don't want to retry on 500's.
      // See https://git.hubteam.com/HubSpot/DesignManagerUI/issues/6172
      xhr.onreadystatechange = () => xhr.status === 500 && xhr.abort();
    }
  });
}
/**
 * POST copy/dependencies/by-id
 */

export function fetchAssetDependencies(data) {
  return http.post(`${BASE_URL}/copy/dependencies/by-id`, {
    data,
    timeout: 35000
  });
}